export const dwProgramDataDev = [
  {
    'id': 'dw-upload-cc',
    'module': 'dw-tool',
    'type': '',
    'routerLink': '/dev-tool/dw-upload-cc'
  }
];
